import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core'

/**
 * Close a sale as one we will not invoice.
 *
 * The reason is required, and the backend enforces it too. This is the one
 * action that ends with a paid sale carrying no legal document, and "why"
 * should be answerable at month end without reconstructing anybody's memory.
 */
export default function AtlaDialog({ row, open, onClose, onConfirm, busy, error }) {
  const [reason, setReason] = useState('')

  React.useEffect(() => {
    if (open) setReason('')
  }, [open, row?.id])

  if (!row) return null

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Faturayı Atla</DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{ mb: 2 }}>
          <b>{row.organisation}</b> için {Number(row.amount_total).toFixed(2).replace('.', ',')} TL tutarındaki satış,
          belge kesilmeden kapatılacak. Bu işlem geri alınamaz.
        </DialogContentText>
        <TextField
          label="Gerekçe"
          fullWidth
          multiline
          rows={2}
          size="small"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Ör. mükerrer ödeme, iade edildi, elle kesildi (fatura no …)"
        />
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Vazgeç
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={busy || !reason.trim()}
          onClick={() => onConfirm(reason.trim())}
        >
          {busy ? 'Kaydediliyor…' : 'Atla'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

AtlaDialog.propTypes = {
  row: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  busy: PropTypes.bool,
  error: PropTypes.string,
}
